import EllipsisVertical from '@assets/images/icons/ellipsis-vertical.svg?react'
import XIcon from '@assets/images/icons/modal/close.svg?react'
import { SyncStatusIndicator } from '@components/ArtBoard/Header/components'
import IconLeft from '@lib/icons/IconLeft'
import { openModal } from '@storeOld/reducers/ui'
import cx from 'classnames'
import type React from 'react'
import { useDispatch } from 'react-redux'

import { DropDown, DropDownList } from '../DropDown'
import type { DropdownItemProps } from '../DropDown/DropDownList'
import css from './Modal.module.scss'

type Classnames = {
  container?: string
  content?: string
  close?: string
  header?: string
  image?: string
  title?: string
  body?: string
  back?: string
}

interface Props extends React.PropsWithChildren {
  title?: string | React.ReactNode
  image?: React.ReactNode
  width?: number
  classnames?: Classnames
  onBack?: {
    to: string
    params?: any
  }
  onClose?: () => void
  moreButtons?: (DropdownItemProps | null | (DropdownItemProps | null)[])[]
  withSyncStatus?: boolean
}

const Modal: React.FC<Props> = ({
  title = '',
  image,
  width,
  onClose = () => {},
  onBack,
  classnames,
  moreButtons,
  children,
  withSyncStatus,
}) => {
  const dispatch = useDispatch()

  const cn: Classnames = {
    container: cx(css.container, classnames?.container),
    content: cx(css.content, classnames?.content),
    close: css.close,
    header: css.header,
    image: css.image,
    title: css.title,
    body: cx(css.body, classnames?.body),
    back: css.back,
  }

  const onClickBack = () => {
    if (!onBack) {
      return
    }

    dispatch(openModal(onBack.to, onBack.params || {}))
  }

  // TODO: Move base Modal component out and extend it for different modal types.
  return (
    <div className={cn.container}>
      <div className={cn.content} style={{ width }}>
        <div className={css.leftControls}>
          {onBack && (
            <div className={cn.back} onClick={onClickBack}>
              <IconLeft size={16} />
              <div>Back</div>
            </div>
          )}
        </div>
        <div className={css.rightControls}>
          {withSyncStatus && <SyncStatusIndicator />}

          {moreButtons && (
            <DropDown contentMinWidth="unset" top={10} right="center">
              {[
                () => (
                  <span role="none" className={css.more}>
                    <EllipsisVertical />
                  </span>
                ),
                () => <DropDownList size="m">{moreButtons}</DropDownList>,
              ]}
            </DropDown>
          )}
          <span role="none" className={css.close} onClick={onClose}>
            <XIcon />
          </span>
        </div>
        {(image || title) && (
          <div className={cn.header}>
            {image && <div className={cn.image}>{image}</div>}
            {title && <span className={cn.title}>{title}</span>}
          </div>
        )}
        <div className={cn.body}>{children}</div>
      </div>
    </div>
  )
}

export default Modal
